import { jsx as t } from "react/jsx-runtime";
import { cn as o } from "./designsystem-ui-react47.js";
function a({ className: r }) {
  return /* @__PURE__ */ t("hr", { className: o("tw-border-t tw-border-gray-200 tw-my-2", r) });
}
export {
  a as CardDivider
};
